import { useState } from 'react';
import { CloseIcon, HamburgerIcon, AddIcon, MoonIcon} from '@chakra-ui/icons';
import RMCSmallLogo from '../assets/RMC_Small_logo.png';
import {
  Button, 
  MenuButton, 
  Link, 
  Flex, 
  Box, 
  Text, 
  HStack, 
  Avatar, 
  Stack, 
  Heading, 
  ChakraProvider, 
  VStack, 
  theme, 
  Divider,
} from '@chakra-ui/react';



const MenuItem = ({ children, isLast, to = '/' }) => {
  return (
    <Text
      mb={{ base: isLast ? 0 : 8, sm: 0 }}
      mr={{ base: 0, sm: isLast ? 0 : 8 }}
      display="block"
    >
      <Link href={to}>{children}</Link>
    </Text>
  );
};

const Header = (props) => {
  const [show, setShow] = useState(false);
  return (
    <ChakraProvider theme={theme}>
    <Flex
      mb={0}
      p={0}
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      w="100%"
    >
      <Box w="200px">
        <MenuItem to="/"> <img style={{width: (248/2), height: (130/2)}} src={RMCSmallLogo} alt = "Rate My Class Logo" /></MenuItem>
      </Box>

      <Box
        display={{ base: show ? 'block' : 'none', md: 'block' }}
        flexBasis={{ base: '100%', md: 'auto' }}
      >
        <Flex
          align="center"
          justify={['center', 'space-between', 'flex-end', 'flex-end']}
          direction={['column', 'row', 'row', 'row']}
          pt={[4, 4, 0, 0]}
        >
          <HStack spacing='20px'>
            <MenuItem to="/departments">Departments</MenuItem>
            <MenuItem to="/reviewForm" isLast>
            
            <Stack direction='row' spacing={4}>
              <Button
                colorScheme='blue'
                leftIcon={<AddIcon boxSize={5} />}
                >
                <Link href={'/reviewform'}>
                  Create Review
                </Link>
              </Button>
              <Box width="5px"/>
            </Stack> 
            
            {/* <Stack direction='row' spacing={4}>
                {<AddIcon />}
                Create Review
            </Stack> */}
            </MenuItem>
          </HStack>
        </Flex>
      </Box>
    </Flex>
    <Divider />
    </ChakraProvider>
  );
};

export default Header;

//<MenuItem to='./assets/darkMode'><Flex alignItems={'center'}>
//{<MoonIcon/>}
//</Flex>
//</MenuItem>